<template>
  <div class="main-div">
    <img class="mb-3" src="../assets/img/logo.png"/>
    <div class="login-div">
      <p class="mt-3 mb-3 text-center"> Reset Password</p>
      <b-form @submit.prevent="changePassword('formChange')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formChange">
        <b-form-group id="passwordGroup">
          <b-form-input id="password"
                      type="password"
                      name="password"
                      v-model="password"
                      v-validate="'required|min:8|confirmed:confirmPassword'"
                      :class="{'input': true, 'is-danger': errors.has('formChange.password') }"
                      required
                      placeholder="Password">
          </b-form-input>
          <i v-show="errors.has('formChange.password')" class="fa fa-warning"></i>
          <span v-show="errors.has('formChange.password')"
                class="help is-danger">{{ errors.first('formChange.password') }}
          </span>
          </b-form-group>
          <b-form-group id="confirmPasswordGroup">
            <b-form-input id="confirmPassword"
                        type="password"
                        name="confirmPassword"
                        v-model="confirmPassword"
                        :class="{'input': true, 'is-danger': errors.has('formChange.password') }"
                        required
                        placeholder="Confirm Password">
            </b-form-input>

        </b-form-group>

      <b-button type="submit" class="w-100" variant="warning">
        Change Password
      </b-button>

    </b-form>
    </div>

 </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';

export default {
  name: 'NewPassword',
  data() {
    return {
      password: null,
      confirmPassword: null,
    };
  },
  created() {
    const token = this.$route.query;
    Session.setResetToken(token);
  },
  methods: {
    async changePassword(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          await API.post('Accounts/reset-password', {
            newPassword: this.password,
          });
          await this.$notify({
            group: 'sitewide',
            title: 'Success!',
            type: 'success',
            text: 'Password has been reset',
          });
          Session.removeResetToken();
          this.$router.push('login');
        }
      } catch (error) {
        const message = error.response.data.error.message;
        if (message.match(/Authorization Required/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Reset password link has been expired!',
          });
        } else {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Error while updating password!',
          });
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div {
  background-color: #2c3e50;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
}

.login-div {
  background-color: white;
  width: 30%;
  height: 260px;
  border-radius: 3px;
}

.w-100 {
  width: 100%;
}

.font-size {
  font-size: 14px;
  color: grey;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/changepassword.vue